import { SignatureMessage } from "./SignatureMessage";
import { EthAddress, ethAddress } from './Ether';

export type WalletFlag = keyof Wallet['flags'];

export type WalletNFTs = {
  contractName: string,
  tokens: string[]
};

export interface Wallet {
  address?: string;
  messageAndSig?: SignatureMessage;
  nfts: Record<EthAddress|string, WalletNFTs>,
  storyNFTs: Record<EthAddress|string, WalletNFTs>,
  flags: {
    loggedIn: boolean,
    founder: boolean,
    storyNFTEditor: boolean,
  }
}


/**  */
export class WalletApi {
  wallet: Wallet;

  constructor(data: Wallet) {
    if (data.address) {
      data.address = ethAddress(data.address!);
    }
    let contract;
    for (contract in data.nfts) {
      const lower = ethAddress(contract);
      if (contract !== lower) {
        data.nfts[lower] = data.nfts[contract];
        delete data.nfts[contract];
      }
    }
    this.wallet = data;
  }

  get address():EthAddress { return ethAddress(this.wallet.address!); }

  is(flag: WalletFlag) {
    return this.wallet.flags[flag]
  }

  hasToken(tokenContract: EthAddress): boolean {
    return tokenContract in this.wallet.nfts && this.wallet.nfts[tokenContract].tokens.length > 0;
  }

  tokensForContract(tokenContract: EthAddress) {
    return this.wallet.nfts[tokenContract]?.tokens;
  }

  allTokens() {
    return this.wallet.nfts;
  }
}
